// onClick handler for selecting and deselecting a filter
// this function formats the selectedFilters into a specific data structure
// that we'll use for the constructing the filters query for the api call
const handleFilterSelect = (filterObj, selectedFilters, setCurrentPageNumber, setSelectedFilters) => {
	let selectedFiltersCopy = [...selectedFilters];

	// we get the taxonomy index in the array
	let existingTaxonomyIndex = selectedFiltersCopy.findIndex(
		(t) => t.taxonomy == filterObj.taxonomy
	);

	// check if taxonomy exists
	if (existingTaxonomyIndex >= 0) {
		// get index of the child filter
		let existingFilterIndex = selectedFiltersCopy[
			existingTaxonomyIndex
		].filters.findIndex((f) => f.slug == filterObj.filters[0].slug);

		let childFilters = selectedFiltersCopy[existingTaxonomyIndex].filters;

		// check if child filter exists
		if (existingFilterIndex >= 0) {
			// if child filter exists we remove it using the index
			childFilters.splice(existingFilterIndex, 1);

			// if there's no child filters left we remove the whole taxonomy
			if (childFilters.length == 0) {
				selectedFiltersCopy.splice(existingTaxonomyIndex, 1);
			}
		} else {
			// we dont have the child filter so we push it into the array of child filters inside taxonomy object
			childFilters.push(filterObj.filters[0]);
		}
	} else {
		selectedFiltersCopy = [...selectedFiltersCopy, filterObj];
	}

	// we reset the page everytime a filter is selected and deselected
	setCurrentPageNumber(1);
	setSelectedFilters(selectedFiltersCopy);
};

export default handleFilterSelect;